<template>
  <a-modal title="详情" :visible="showTubeView" :width="800" destroyOnClose @ok="handleOk" @cancel="closeTubeView">
    <a-modal
      title="地图"
      style="top: 20px"
      :width="800"
      v-model="mapVisible"
      @ok="mapVisible = false"
      @cancel="mapVisible = false"
    >
      <lonlat-map ref="lonlatMaps" @handleMapOk="handleMapOk"></lonlat-map>
    </a-modal>
    <!-- <a-modal
      title="轨迹查看"
      :visible="showSmallMap"
      :width="800"
      destroyOnClose
      @ok="handleOk2"
      @cancel="handleOk2"
    >
      <TravelMap></TravelMap>
    </a-modal> -->
    <!-- style="position: absolute; left: 18rem; z-index: 999; top: 3rem" -->
    <a-form-model
      class="log-form"
      :model="addOrUpdateForm"
      ref="addOrUpdateForm"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 14 }"
    >
      <a-row style="line-height: 40px">
        <a-col :span="12">任务编号：{{ addOrUpda.taskNumber }}</a-col>
        <a-col :span="12">任务名称: {{ addOrUpda.taskName }}</a-col>
        <a-col :span="12">来源：{{ addOrUpda.origin }}</a-col>
        <a-col :span="12">巡检泵房：{{ addOrUpda.pumpName }}</a-col>
        <a-col :span="12">预期开始时间：{{ addOrUpda.predictStime }}</a-col>
        <a-col :span="12"
          >预期处理时长：<span v-if="addOrUpda.planTime !== null">{{ addOrUpda.planTime }}天</span></a-col
        >
        <a-col :span="12">开始时间：{{ addOrUpda.startTime }}</a-col>
        <a-col :span="12"
          >处理时长：<span v-if="addOrUpda.processingTime !== null">{{ addOrUpda.processingTime }}</span></a-col
        >
        <a-col :span="12"
          >泵房状态：<span v-if="addOrUpda.pumpStatus == 0"><a-tag color="rgb(50, 205, 50)"> 正常 </a-tag></span>
          <span v-if="addOrUpda.pumpStatus == 1"><a-tag color="rgb(255, 99, 71)"> 异常 </a-tag></span></a-col
        >
        <a-col :span="12"
          >任务状态：
          <span v-if="addOrUpda.status == 0"><a-tag color="rgb(255, 99, 71)"> 未开始 </a-tag></span>
          <span v-if="addOrUpda.status == 1"><a-tag color="#f98303"> 执行中 </a-tag></span>
          <span v-if="addOrUpda.status == 2"><a-tag color="#40a9ff"> 已提交 </a-tag></span>
          <span style="color: blue" v-if="addOrUpda.status == 3"
            ><a-tag color="rgb(50, 205, 50)"> 已完成 </a-tag></span
          ></a-col
        >
        <a-col :span="12">负责人：{{ addOrUpda.principalName }}</a-col>
        <a-col :span="12">任务描述：{{ addOrUpda.description }}</a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">处理结果：{{ addOrUpda.draftConsequence }}</a-col>
        <a-col :span="12">
          <a-col :span="12">
            <div class="fileDiv">
              处理图片：
              <ul>
                <li class="fileLi" v-for="item in addOrUpda.draftCompleteFileNames" :key="item.url">
                  <img :src="item.url" alt="" style="width: 80px; height: 80px" @click="clicimg(item.url)" />
                </li>
              </ul>
            </div> </a-col
        ></a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12"
          >处理记录：
          <a-form-model-item label="" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
            <a-timeline>
              <a-timeline-item v-for="item in addOrUpda.records" :key="item.id">
                <span>{{ item.createTime }}</span>
                <span style="color: blue; margin-left: 20px">{{ item.name }}</span>
                <span style="margin-left: 10px">{{ item.message }}</span>
              </a-timeline-item>
            </a-timeline>
          </a-form-model-item></a-col
        >
        <a-col :span="12"></a-col>
      </a-row>
    </a-form-model>
    <a-modal
      title="图片"
      style="top: 20px"
      :width="800"
      :footer="null"
      :visible="visiblest"
      :confirm-loading="confirmLoading"
      @cancel="handleCancelhlg"
    >
      <img :src="this.pumpUrlg" :alt="this.pumpUrlg" style="width: 100%; height: 100%" />
    </a-modal>
    <track-travel ref="TrackTravel"></track-travel>
  </a-modal>
</template>
<script>
import moment from 'moment'
import addModal from './AddModal'
// import TravelMap from './TravelMap'
import TrackTravel from './TrackTravel'
import LonlatMap from '../../../maintenance/EventManagement/modules/lonlatMap.vue'
export default {
  components: {
    addModal,
    // TravelMap,
    TrackTravel,
    LonlatMap,
  },
  props: {},
  data() {
    return {
      mapVisible: false,
      queryOneUrl: '/pipe-network/inspection_tasks/',
      queryUrl: '/pipe-network/user_water_meters/page/geophysical-point-numbers',
      addOrUpdateUrl: '/pipe-network/inspection_tasks',
      exportFileName: '影响用户数据.xlsx',
      exportDataUrl: 'pipe-network/user_water_meters/export',
      showTubeView: false,
      id: '',
      showSmallMap: false,
      addOrUpda: {},
      addOrUpdateForm: {
        taskType: '',
        startTime: '',
        zoneId: '',
        description: '',
        address: '',
        assistPersons: [],
        publisherName: '',
        eventNo: '',
      },
      eventTypeList: [],
      assistPersonsList: [],
      currentId: '',
      visiblest: false,
      pumpUrlg: '',
    }
  },
  computed: {
    rules() {
      return {}
    },
  },
  created() {},
  methods: {
    moment,
    //缩略图
    clicimg(i) {
      this.pumpUrlg = i
      this.visiblest = true
    },
    handleCancelhlg() {
      this.visiblest = false
      this.pumpUrlg = ''
    },
    handleChange(value) {
      this.addOrUpdateForm.principal = value
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    addPepople(list) {
      this.assistPersonsList = list
      this.addOrUpdateForm.assistPersons = []
      list.map((item) => {
        this.addOrUpdateForm.assistPersons.push(item.key)
      })
    },
    openSmallMap() {
      this.showSmallMap = true
    },
    checkTrack() {
      console.log(this.addOrUpdateForm.id)
      this.$refs.TrackTravel.edit(this.addOrUpdateForm.id)
    },
    handleOk2(e) {
      e.preventDefault()
      this.showSmallMap = false
    },
    handleOk(e) {
      e.preventDefault()
      this.closeTubeView()
    },
    _updateForm(real, data) {
      let keys = Object.keys(real)
      let dataKeys = Object.keys(data)
      let newObject = {}
      keys.map((key) => {
        if (dataKeys.includes(key)) {
          newObject[key] = data[key]
        } else {
          newObject[key] = real[key]
        }
      })
      return newObject
    },
    edit(id) {
      this.showTubeView = true
      this.currentId = id
      this.addOrUpdateForm = {
        taskType: '',
        startTime: '',
        zoneId: '',
        description: '',
        address: '',
        assistPersons: [],
        publisherName: '',
        zoneName: '',
        eventNo: '',
      }

      this.$nextTick(() => {
        this.$refs.addOrUpdateForm.resetFields()
        if (id) {
          this.isUpdate = true
          this.$http
            .get(`${this.queryOneUrl}/${this.currentId}`)
            .then(({ data }) => {
              
              // this.addOrUpdateForm = { ...this._updateForm(this.addOrUpdateForm, data) }
              this.addOrUpda = data
            })
            .catch(() => {})
        }
      })
    },
    closeTubeView() {
      this.showTubeView = false
      this.$refs.addOrUpdateForm.resetFields()
      this.assistPersonsList = []
    },
    addAddress() {
      this.mapVisible = true
      if (this.addOrUpdateForm.place) {
        var pointData = this.addOrUpdateForm.place.split(',')
        var newPointData = pointData.map((item) => {
          return (item = parseFloat(item))
        })
        console.log(newPointData, this.$refs) // [113.678351, 25.538859]
        this.$nextTick(() => {
          this.$refs.lonlatMaps.changepoint(newPointData)
        })
      } else {
        this.$nextTick(() => {
          this.$refs.lonlatMaps.changepoint([0, 0])
        })
      }
    },
    handleMapOk() {},
  },
}
</script>

<style lang="less" scoped>
/deep/.ant-timeline {
  margin: 24px;
}
// /deep/.ant-form-item-label{
//   text-align: left;
// }
</style>
